import classNames from 'classnames';
import PropTypes from 'prop-types';

import SvgColorImg from './SvgColorImg';

// The pointing hand marking what waits on the viewer, on its own circle so it
// catches the eye in a column of plain pictograms. The white copy of the same
// drawing sits behind it, on the one grid cell, and keeps the green hand
// readable wherever it overlaps the circle.
const WaitingOnYouIcon = function WaitingOnYouIcon(props) {
  const {
    className = 'h-5 w-5',
    handClassName = 'h-4 w-4',
  } = props;

  return (
    <div
      className={classNames(
        'shrink-0 rounded-full bg-pxTask/20 grid place-items-center',
        className,
      )}
    >
      <SvgColorImg
        src="/images/svg/gui/pointingHandOutline.svg"
        className={classNames('col-start-1 row-start-1 shrink-0 fill-white', handClassName)}
        imgColorAsCssFill
      />
      <SvgColorImg
        src="/images/svg/gui/pointingHand.svg"
        className={classNames('col-start-1 row-start-1 shrink-0 fill-pxTask', handClassName)}
        imgColorAsCssFill
      />
    </div>
  );
};

WaitingOnYouIcon.propTypes = {
  className: PropTypes.string,
  handClassName: PropTypes.string,
};

export default WaitingOnYouIcon;
